import vuexLocal from "@/plugins/vuex-persist";
import { authModule } from "@/vuex/auth";
import { AccountManagementModule } from "@/vuex/modules/account/account.index";
import { ThirdPartyAppModule } from "@/vuex/modules/thirdPartyApp/thirdPartyApp.index";
import { RootState } from "@/vuex/types";
import Vue from "vue";
import Vuex, { Plugin, StoreOptions } from "vuex";

Vue.use(Vuex);
const appVer = `${process.env.VUE_APP_VERSION}`;
const storeDef: StoreOptions<RootState> = {
  state: {
    appName: "Helix Core",
    appVersion: appVer
  },
  modules: {
    authModule,
    AccountManagementModule,
    ThirdPartyAppModule
  },
  plugins: [vuexLocal.plugin as Plugin<RootState>]
};

export const store = new Vuex.Store<RootState>(storeDef);
